import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Radio from '@/components/common/elements/Radio';

const RadioWidget = ({ disabled, id, label, options, onChange, value }) => (
  <div className="flex flex-col">
    <div>
      <div className="inline-block text-[12px] font-bold text-[#212529] font-['Open_Sans'] mt-[0.3vh] mb-1 tracking-tight">
        <FormattedMessage id={label} />
      </div>

      <div className="flex flex-wrap items-center">
        {options.enumOptions.map(option => (
          <div key={`${id}-${option.value}`} className="flex flex-row items-center mr-4 mb-2">
            <Radio
              name={id}
              className="mr-2"
              id={`${id}-${option.value}`}
              data-cy={`${id}-${option.value}`}
              value={option.value.toString()}
              checked={value === option.value}
              onChange={evt => {
                const val = evt.target.value;
                const converted = (val === 'true' && typeof option.value === 'boolean') ? true 
                                : (val === 'false' && typeof option.value === 'boolean') ? false 
                                : val;
                onChange(converted);
              }}
              disabled={disabled}
            />
            <label 
              htmlFor={`${id}-${option.value}`}
              data-cy={`${id}-${option.label}`} 
              className="m-0 cursor-pointer font-['Open_Sans'] text-[14px] font-normal text-[#212529] leading-none"
            >
              <FormattedMessage id={option.label} />
            </label>
          </div>
        ))}
      </div>
    </div>
  </div>
);

RadioWidget.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
};

RadioWidget.defaultProps = {
  disabled: false,
  value: null,
};

export default RadioWidget;
